/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  title: {
    id: "b2b.uzivatele-grid.title",
    defaultMessage: "Users"
  }
});

export default () => useMessages(MESSAGES);
